<template>
  <div :style="{ height: '100%' }">
    <PreView :option="option"> </PreView>
  </div>
</template>
<script>
import PreView from "../component/preView";

export default {
  components: {
    PreView
  },

  data: () => ({
    src: "",
    name: "",
    option: {}
  }),
  created() {
    this.option = {
      src: this.$route.query.src,
      name: this.$route.query.name ? this.$route.query.name : "文件.doc"
    };

    this.src = this.$route.query.src;
    this.name = this.$route.query.name ? this.$route.query.name : "文件.doc";
  },

  //   destroyed(){
  //      window['DocsAPI'].docEditor.destroyEditor();
  //   },

  methods: {
    onReady() {
      // this.innerAlert('Document editor ready')
      console.log("onReady");
    },
    onDocumentStateChange() {
      console.log("onDocumentStateChange");
    },
    onRequestEditRights() {
      console.log("onRequestEditRights");
      location.href = location.href.replace(RegExp("action=view&?", "i"), "");
    },
    onError(event) {
      console.log("onError===》", event);
    },
    onOutdatedVersion() {
      console.log("onOutdatedVersion");
    }
  }
};
</script>

<style lang="scss" scoped></style>
